/* src/app/merchants/merchant-accounts/merchant-accounts.component.css */
.panel-alert {
  border-radius: 0px;
  border: 1px solid #414141;
  background: none;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  -webkit-box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  -moz-box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  margin-top: 20px;
}
.panel-alert .panel-heading {
  background-image: none;
  background-color: #c1554e;
  border: none;
  border-radius: 0;
  color: #fff;
  font-weight: 600;
  opacity: 1;
  height: 40px;
  padding-left: 20px;
  padding-top: 7px;
}
.panel-alert .panel-body {
  padding: 15px;
  opacity: 1;
  background-color: #ffffff;
}
.panel label {
  font-weight: 600;
}
.fa {
  font-size: 9pt;
}
.sync {
  position: fixed;
  top: 133px;
}
/*# sourceMappingURL=merchant-accounts.component.css.map */
